import type { ServiceabilityDestinationDecision } from "@/helpers/serviceability";
import { getXfinityBuyflowRoute } from "@/lib/clickthrough-destination";

const XFINITY_DESTINATION_HOSTS = new Set([
  "www.xfinity.com",
  "xfinity.com",
  "www.stg.xfinity.com",
]);

export const getDestinationTrackingAttributes = ({
  url,
  source,
}: ServiceabilityDestinationDecision): Record<string, string> => {
  const isRelative = url.startsWith("/") && !url.startsWith("//");

  try {
    const parsedUrl = new URL(url, "https://relative.invalid");
    const hostname = parsedUrl.hostname.toLowerCase().replace(/\.$/, "");
    const isXfinity = XFINITY_DESTINATION_HOSTS.has(hostname);
    const destinationHost = isRelative
      ? "relative"
      : isXfinity
        ? hostname
        : "external";
    const destinationRoute = isXfinity
      ? (getXfinityBuyflowRoute(parsedUrl.pathname) ?? "other")
      : "other";
    const offerId = parsedUrl.searchParams.get("offerId");
    const appEnvironment =
      process.env.NEXT_PUBLIC_APP_ENV === "production"
        ? "production"
        : "nonproduction";
    const isExpectedBuyflowHost =
      appEnvironment === "production"
        ? hostname === "www.xfinity.com" || hostname === "xfinity.com"
        : hostname === "www.stg.xfinity.com";

    return {
      destinationSource: source,
      appEnvironment,
      destinationHost,
      destinationRoute,
      destinationHostMismatch: String(
        destinationRoute !== "other" && !isExpectedBuyflowHost
      ),
      ...(destinationRoute === "/digital/plans-offers" &&
      offerId &&
      offerId.length <= 100 &&
      /^\d+(?:\|\d+)*$/.test(offerId)
        ? { destinationOfferId: offerId }
        : {}),
    };
  } catch {
    return {
      destinationSource: source,
      appEnvironment:
        process.env.NEXT_PUBLIC_APP_ENV === "production"
          ? "production"
          : "nonproduction",
      destinationHost: "invalid",
      destinationRoute: "other",
      destinationHostMismatch: "false",
    };
  }
};
